import type { PropsWithChildren } from "react";
import { PorchPassLogo } from "src/assets/icons/porch-pass-logo";
import { currentYear } from "../../constants";
import { StyledLink } from "src/components/common";

export default ({ children }: PropsWithChildren) => {
  return (
    <div className="box-border flex min-h-full flex-col items-center justify-between gap-5 px-0 py-10 pb-8 text-center">
      <PorchPassLogo width={130} height={32} />
      <div className="flex flex-col items-center gap-5">{children}</div>
      <div className="flex justify-between gap-2.5 px-2.5 text-xs text-[#4a5466] max-sm:flex-col">
        <StyledLink
          className="text-[#4a5466] underline"
          target="_blank"
          to="https://www.porchpass.com/privacy"
        >
          Privacy
        </StyledLink>
        <StyledLink
          className="text-[#4a5466] underline"
          target="_blank"
          to="https://www.porchpass.com/terms"
        >
          Terms of use
        </StyledLink>
        <StyledLink
          className="text-[#4a5466] underline"
          target="_blank"
          to="https://www.porchpass.com/contact"
        >
          Support
        </StyledLink>
        <span>© {currentYear} PorchPass Inc.</span>
      </div>
    </div>
  );
};
